module.exports = __webpack_public_path__ + "media/images/bg_access_mv_sp-5ebfbe21c9959b155271cb019d7b203b.jpg";